'use strict';

/*global services*/

function KeyShortcutsManager() {
  this.shortcuts = {};
  this.shortcutHandlers = {};
  this.hightPriorityKeys = [
    /*ESC*/
    27,

    /*Fx*/
    112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123
  ];

  this.init();
}

KeyShortcutsManager.prototype = $.extend({}, {
  constructor: 'KeyShortcutsManager',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $(document).on('keydown', function (e) {
      e = e || window.event;

      var keyCode = e.keyCode || e.which;

      var originalElement = e.originalEvent.srcElement || e.originalEvent.originalTarget;
      if (originalElement && (_this.isHightPriorityKey(keyCode) || $.inArray($(originalElement).prop('tagName').toLowerCase(), ['input', 'select', 'textarea']) === -1)) {
        if (services.get('configurations').param('using_quick_functions')) {
          _this.handleKeyCode(keyCode);

          if (_this.preventEvent(keyCode)) {
            return false;
          }
        }
      }
    });
  },

  //----------------------------------------------------------------------------

  preventEvent: function preventEvent(keyCode) {
    var _this = this;

    var preventEvent = false;
    $.each(_this.shortcuts, function (shortcut, setting) {
      if (setting.keyCode === keyCode) {
        preventEvent = true;
        return false;
      }
    });

    return preventEvent;
  },

  updateTitle: function updateTitle(title, shortcut) {
    var _this = this;

    if (services.get('configurations').param('using_quick_functions')) {
      if (shortcut in _this.shortcuts) {
        var shortcutSetting = _this.shortcuts[shortcut];
        title = title + ' (' + shortcutSetting.title + ')';
      }
    }

    return title;
  },

  isHightPriorityKey: function isHightPriorityKey(keyCode) {
    var _this = this;

    return $.inArray(keyCode, _this.hightPriorityKeys) !== -1;
  },

  handleKeyCode: function handleKeyCode(keyCode) {
    var _this = this;

    $.each(_this.shortcuts, function (shortcut, setting) {
      if (setting.keyCode === keyCode) {
        _this.executeShortcut(shortcut);
      }
    });

    return _this;
  },

  executeShortcut: function executeShortcut(shortcut) {
    var _this = this;

    var handlers = _this.shortcutHandlers[shortcut];
    handlers = handlers.reverse();

    $.each(handlers, function (key, handler) {
      handler.fn();

      return false;
    });

    return _this;
  },

  registerShortcut: function registerShortcut(shortcut, fn, source) {
    var _this = this;

    source = source || '__default__';

    _this.shortcutHandlers[shortcut].push({
      fn: fn,
      source: source
    });

    return _this;
  },

  unregisterShortcut: function unregisterShortcut(shortcut, source) {
    var _this = this;

    source = source || '__default__';

    var handlers = [];
    $.each(_this.shortcutHandlers[shortcut], function (key, handler) {
      if (handler.source !== source) {
        handlers.push(handler);
      }
    });

    _this.shortcutHandlers[shortcut] = handlers;

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.shortcuts.confirm = {
      keyCode: services.get('configurations').param('quick_function_button_confirm'),
      title: services.get('configurations').param('quick_function_button_confirm_title')
    };

    _this.shortcuts.cancel = {
      keyCode: services.get('configurations').param('quick_function_button_cancel'),
      title: services.get('configurations').param('quick_function_button_cancel_title')
    };

    _this.shortcuts.prev = {
      keyCode: services.get('configurations').param('quick_function_button_prev'),
      title: services.get('configurations').param('quick_function_button_prev_title')
    };

    _this.shortcuts.next = {
      keyCode: services.get('configurations').param('quick_function_button_next'),
      title: services.get('configurations').param('quick_function_button_next_title')
    };

    $.each(_this.shortcuts, function (shortcut/*, setting*/) {
      _this.shortcutHandlers[shortcut] = [];
    });

    _this.registerCallbacks();

    return _this;
  }
});
